import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MoveRight } from "lucide-react";
import { tvUnits } from "@/tvunits";

export function TvUnitsPage() {
  return (
    <div data-testid="tv-units-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">The TV unit edit</span>
          <h1>A considered frame<br /><i>for your everyday.</i></h1>
          <p>The screen is where the family gathers — our media walls give it a setting worthy of the room. Five compositions across Lamitex laminate, ceramic, laminate and velvety Senosan acrylic, each engineered around your wall.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start a conversation <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src={tvUnits[0].image} alt={tvUnits[0].alt} />
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">The collection</span>
          <h2>Five frames.<br /><i>Endless evenings.</i></h2>
          <div className="series-grid">
            {tvUnits.map((t) => (
              <Link to={`/tv-units/${t.slug}`} className="series-card" key={t.slug} data-testid={`tv-unit-card-${t.index}`}>
                <img src={t.image} alt={t.alt} />
                <div>
                  <span>{t.index} / 05</span>
                  <h3>{t.name}</h3>
                  <p>{t.finish} · {t.layout}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export function TvUnitDetail() {
  const { slug } = useParams();
  const unit = tvUnits.find((t) => t.slug === slug);

  if (!unit) {
    return (
      <section className="kitchen-detail" data-testid="tv-unit-not-found">
        <Link to="/tv-units" className="back-link" data-testid="back-to-collection-link">
          <ArrowLeft size={15} /> Back to the collection
        </Link>
        <h1 className="detail-missing">This TV unit is not in our collection.</h1>
      </section>
    );
  }

  return (
    <section className="kitchen-detail" data-testid="tv-unit-detail-page">
      <Link to="/tv-units" className="back-link" data-testid="back-to-collection-link">
        <ArrowLeft size={15} /> Back to the collection
      </Link>
      <div className="detail-grid">
        <figure className="detail-image" data-testid="tv-unit-detail-image">
          <img src={unit.image} alt={unit.alt} />
          <figcaption>{unit.index} / 05 — {unit.finish}</figcaption>
        </figure>
        <div className="detail-specs">
          <span className="eyebrow">TV Unit {unit.index} / 05</span>
          <h1 data-testid="tv-unit-detail-title">{unit.name}</h1>
          <p className="detail-description" data-testid="tv-unit-detail-description">{unit.description}</p>
          <dl className="spec-list" data-testid="tv-unit-spec-list">
            <div className="spec-row" data-testid="spec-finish">
              <dt>Finish</dt>
              <dd>{unit.finish}</dd>
            </div>
            <div className="spec-row" data-testid="spec-layout">
              <dt>Layout</dt>
              <dd>{unit.layout}</dd>
            </div>
            <div className="spec-row" data-testid="spec-materials">
              <dt>Materials</dt>
              <dd>
                <ul>
                  {unit.materials.map((m) => <li key={m}>{m}</li>)}
                </ul>
              </dd>
            </div>
          </dl>
          <Link to="/contact" className="button" data-testid="tv-unit-consultation-cta">
            Book a private consultation <MoveRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
}
